
import Hashtag from "../../../assets/duotone/Hashtag.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HashtagIcon({ className, dataTestid = "HashtagIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hashtag data-testid={dataTestid} className={classes} {...rest} />
  );
}
